import { FC } from 'react';
import { SelectButton } from 'primereact/selectbutton';
import { LogicalOperator } from '../../models/waterfall';
import styles from './LogicalOperatorToggle.module.css';

interface LogicalOperatorToggleProps {
  value: LogicalOperator;
  onChange: (value: LogicalOperator) => void;
}

export const LogicalOperatorToggle: FC<LogicalOperatorToggleProps> = ({ value, onChange }) => {
  const options = [
    { label: 'AND', value: LogicalOperator.And },
    { label: 'OR', value: LogicalOperator.Or },
  ];

  return (
    <div className={styles.container}>
      <SelectButton value={value} options={options} onChange={(e) => onChange(e.value)} />
    </div>
  );
};
